module.exports = __webpack_public_path__ + "1cf8a14a37cc1e2a0b69c51c26e22695.pdf";